<template>
  <div>
    <div class="row">
      <div class="col-md-11">
        <b-button variant="link" class="p-0" pill @click="addNewTier"
                  :class="{'mb-3': model.tiers && model.tiers.length > 0}">
          <font-awesome-icon :icon="'plus-circle'"/>
          {{ $t('New Tier') }}
        </b-button>
      </div>
    </div>
    <div class="row" v-for="(tier, index) in model.tiers" :key="tier.uuid">
      <div class="col-md-11">
        <div class="row">
          <div class="col-md-4">
              <label>
                {{ $t('Percentage') }}
              </label>
              <percentage-input-widget :label="false" :model="tier" attribute="percent"
                :disabled="disabledInputs=='p' || model.applies_to != 'lot'"/>
          </div>
          <div class="col-md-4">
              <label>
                {{ $t('Flat Price') }}
              </label>
              <currency-input-widget :label="false" :model="tier" attribute="flat_price"
                  :disabled="disabledInputs=='f'"/>
          </div>
          <div class="col-md-4">
              <label>
                {{ $t('Over') }} <span class="text-danger">*</span>
              </label>
              <currency-input-widget :label="false" :model="tier" attribute="amount_over" :disabled="index == 0"/>
          </div>
        </div>
      </div>
      <div class="col-md-1 text-left" v-if="index > 0">
        <b-tooltip :target="`remove-tier-button-${index}`" :title="$t('Delete')"/>
        <font-awesome-icon class="text-danger hover-cursor"
                           :id="`remove-tier-button-${index}`"
                           @click="removeTierByIndex(index)"
                           style="font-size: 1.5em;margin-top: .2em"
                           :icon="'times'"/>
      </div>
    </div>
  </div>
</template>

<script>
  import PercentageInputWidget from '@/core/widgets/PercentageInputWidget';
  import CurrencyInputWidget from '@/core/widgets/CurrencyInputWidget';
  import VendorChargeTier from './VendorChargeTier.model';

  export default {
    name: 'VendorChargeTiers',
    components: {CurrencyInputWidget, PercentageInputWidget},
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    computed: {
      disabledInputs() {
        let v = null;
        for (let tier of this.model.tiers) {
          if (tier.flat_price) {
            v = 'p';
            break;
          }
          if (tier.percent) {
            v = 'f';
            break;
          }
        }
        return v;
      }
    },
    watch: {
      disabledInputs(v) {
        this.$emit('update-percentage-used', v == 'f');
      }
    },
    methods: {
      addNewTier() {
        let amountOver = this.model.tiers.length ? null : 0;
        this.model.tiers.push(new VendorChargeTier({amount_over: amountOver, percent: '', flat_price: null}));
      },
      removeTierByIndex(index) {
        for (let i = 0; i < this.model.tiers.length; i++) {
          if (i === index) {
            this.model.tiers.splice(i, 1);
            break;
          }
        }
      }
    },
    beforeMount() {
      if (this.model && this.model.tiers) {
        this.model.tiers = this.model.tiers.map(data => new VendorChargeTier(data));

        if (this.model.tiers.length === 0) {
          this.addNewTier();
        }
      }
    },
    mounted() {
      this.$emit('update-percentage-used', this.disabledInputs == 'f');
    }
  }
</script>

<style scoped>
</style>
